/**
 * @module ol/MapProperty
 */

/**
 * @enum {string}
 */
export default {
  LAYERGROUP: 'layergroup',
  SIZE: 'size',
  TARGET: 'target',
  VIEW: 'view'
};

//# sourceMappingURL=MapProperty.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/MapProperty.js
// module id = ../../../../ol/MapProperty.js
// module chunks = 3